import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
export var PhoneCallPinLayout = function PhoneCallPinLayout(_ref) {
  var pinInput = _ref.pinInput,
    errorMessage = _ref.errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['number-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['number-prefix']
  }, "+7(", /*#__PURE__*/React.createElement("div", {
    className: styles['dots']
  }, "\u2022\u2022\u2022"), ")", /*#__PURE__*/React.createElement("div", {
    className: cn(styles['dots'], styles['dots--after-bracket'])
  }, "\u2022\u2022\u2022")), pinInput), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['error-message']
  }, errorMessage));
};